import { Alert } from '@one-thd/sui-atomic-components';
import React from 'react';
import '../../../styles/order-details.scss';
import { pushErrorEvent } from '../../../utils/analytics';
import { getApiErrorCode } from '../../../utils/api-error-code';
import { useTrackOncePerKey } from '../../../hooks/useTrackOnce';

// prop is not required if we are only using generic error message

export const TRACK_SHIPMENT_ERROR_MESSAGE =
  'We were unable to retrieve your shipment details. Refresh the page and try again.'; // move to constant file.

export const trackShipmentPostPageError = (error?: unknown) => {
  pushErrorEvent(
    'track shipment',
    getApiErrorCode(error),
    TRACK_SHIPMENT_ERROR_MESSAGE,
    'inline',
    'system',
  );
};

interface ITrackShipmentError {
  error?: unknown;
}

export const TrackShipmentError = ({ error }: ITrackShipmentError) => {
  // Track once per distinct error code so a late-arriving real error updates
  // the reported code instead of locking in the initial `n/a`.
  useTrackOncePerKey(getApiErrorCode(error), () =>
    trackShipmentPostPageError(error),
  );

  return (
    <div className="track-shipment-alert">
      <Alert status="error" size="large">
        {TRACK_SHIPMENT_ERROR_MESSAGE}{' '}
      </Alert>
    </div>
  );
};
